import { CSSProperties, ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Divider.module.scss';

type DividerProps = {
  /** Optional property for overriding styles. */
  className?: string;
  /** Height of the separator border line (in pixels). Note that the entire component has a fixed height of 16px. */
  height: number;
  /** Optional property for overriding styles. */
  style?: CSSProperties;
  /** Default width is full */
  width?: 'full' | 'large' | 'medium' | 'small';
  /** Optional divider text */
  children?: ReactNode;
  /** Whether this should act as a semantic separator or be hidden from screen readers */
  'aria-hidden'?: boolean;
};

/**
 * Renders a horizontal rule with optional text dividing the middle of it. Used
 * to create visual separation between related content.
 */
export const Divider = ({
  className,
  height,
  style,
  width = 'full',
  children,
  'aria-hidden': ariaHidden = undefined,
}: DividerProps) => {
  return (
    <div
      role="separator"
      aria-hidden={ariaHidden}
      className={clsx(styles.root, className)}
      style={{
        ...style,
        '--zds-internal-divider-height': `${height}px`,
      }}
      data-width={width}
    >
      {children && <span className={styles.content}>{children}</span>}
    </div>
  );
};
